"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StarRating_1 = require("./StarRating");
exports.default = StarRating_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StarRating/index.js
// module id = 1812
// module chunks = 8